module.exports = __webpack_public_path__ + "static/img/saimenInstallForWin_pic11.32c61e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForWin/saimenInstallForWin_pic11.png
// module id = 578
// module chunks = 1